import { apiSlice } from "features/api/apiSlice";
import { transformAppointment } from "./transformAppointment";

const getAppointments = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAppointments: build.query({
      query: () => "/appointments?limit=500",
      transformResponse: (res) => res.d.items.map(transformAppointment),
      providesTags: (result) => {
        if (result) {
          const tagged = result.map(({ id }) => ({ type: "Appointment", id }));

          return [...tagged, "Appointment"];
        } else {
          return ["Appointment"];
        }
      },
    }),
  }),
});

export const { useGetAppointmentsQuery } = getAppointments;
